import {
  CreateDimConfigurationInput,
  DimConfiguration
} from "shared/types/__generated__/graphql"

import { DimConfigurationFragment } from "entities/dim-configuration/graphql/fragments.generated"
import { useScrollController } from "features/scroll-management/model/useScrollController"

import { DimConfigurationAdminPageView } from "./DimConfigurationAdminPageView"
import { useDimConfigurationAdminPageViewModel } from "./model/useDimConfigurationAdminPageViewModel"

export interface DimConfigurationAdminPageProps {
  configurations: DimConfigurationFragment[]
  isLoading: boolean
  error?: Error
  isCreating: boolean
  isUpdating: boolean
  isDeleting: boolean
  createConfiguration: (input: CreateDimConfigurationInput) => Promise<void>
  deleteConfiguration: (id: string) => Promise<void>
  onChange: (config: DimConfiguration) => Promise<void>
}

export function DimConfigurationAdminPage({
  configurations,
  isLoading,
  error,
  isCreating,
  isUpdating,
  isDeleting,
  createConfiguration,
  deleteConfiguration,
  onChange
}: DimConfigurationAdminPageProps) {
  useScrollController()

  const viewModel = useDimConfigurationAdminPageViewModel({
    configurations,
    deleteConfiguration,
    createConfiguration,
    onChange
  })

  return (
    <DimConfigurationAdminPageView
      {...viewModel}
      isLoading={isLoading}
      error={error}
      isCreating={isCreating}
      isUpdating={isUpdating}
      isDeleting={isDeleting}
      configurations={configurations}
    />
  )
}
